import React from "react";
import LegalPage, { DocSections } from "@/pages/legal/LegalPage";
import { DELIVERY } from "@/pages/legal/_content";

const DeliveryPolicy = () => <LegalPage doc={DELIVERY}><DocSections sections={DELIVERY.sections}/></LegalPage>;
export default DeliveryPolicy;
